import { render, staticRenderFns } from "./doctorQuotationList.vue?vue&type=template&id=29f0e954&scoped=true&"
import script from "./doctorQuotationList.vue?vue&type=script&lang=js&"
export * from "./doctorQuotationList.vue?vue&type=script&lang=js&"
import style0 from "./doctorQuotationList.vue?vue&type=style&index=0&id=29f0e954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f0e954",
  null
  
)

export default component.exports